"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const loading_style_1 = require("./loading.style");
const Loading = ({ color = 'contained', small }) => {
    const { container } = (0, loading_style_1.default)(color, small);
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: container, children: (0, jsx_runtime_1.jsx)("div", { className: "loading", children: (0, jsx_runtime_1.jsxs)("div", { className: "kkEllipsis", children: [(0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {})] }) }) }));
};
exports.default = Loading;
